import { BulkAddProductsToShoppingCartResponse } from '../../store/api';
import { globalErrorResponse, showNotification } from '../../store/notifications/actions';
import { invalidateCartSummaryQuery } from './useCartSummaryQuery';
import { failAddToCart } from '../../store/products/actionsCart';
import { AppDispatch } from '../../store';
import { ListContentSource } from '../../store/constants';
import { TFunction } from 'i18next';

type Params = {
    dispatch: AppDispatch;
    setLoading: (loading: boolean) => void;
    performChecks: boolean;
    source: ListContentSource;
    notificationMessage?: string;
    apiCallback: () => Promise<BulkAddProductsToShoppingCartResponse>;
    t: TFunction;
    callback?: () => void;
};

export const bulkUpdateToCart = ({
    dispatch,
    setLoading,
    performChecks,
    source,
    notificationMessage,
    apiCallback,
    t,
    callback = () => {}
}: Params): Promise<BulkAddProductsToShoppingCartResponse> => {
    setLoading(true);

    return apiCallback()
        .then(data => {
            const fallbackPriceTiers = data.fallbackPriceTiers ?? [];
            const alreadyInListProducts = data.alreadyInListProducts ?? [];
            const preOrderedProducts = data.preOrderedProducts ?? [];

            if (
                fallbackPriceTiers.length === 0 &&
                alreadyInListProducts.length === 0 &&
                preOrderedProducts.length === 0
            ) {
                dispatch(showNotification(notificationMessage ?? t('notifications.addToCartBulk.success')));
                invalidateCartSummaryQuery().then();

                callback();
            }
            return data;
        })
        .catch(error => {
            if (!performChecks) {
                dispatch(failAddToCart(error, source));
            } else {
                dispatch(globalErrorResponse(error));
            }
            return Promise.reject(error);
        })
        .finally(() => setLoading(false));
};
